import React from 'react';
import Collapsible from 'react-collapsible';
import { FormSection } from 'redux-form';

import styles from './emailsConfiguration.module.scss';
import { ToggleFieldComponent } from 'components/form/toggle/toggleField.component';
import { AppTextField } from 'components/form/appTextField';

export const EmailsConfigurationGroup = () => (
  <div className={styles.wrapper}>
    <Collapsible trigger="Emails" contentInnerClassName={styles.innerContent}>
      <AppTextField name="emailFromAddress" label="Sender Email" key="emailFromAddress" />
      <AppTextField name="emailFromName" label="Sender Name" key="emailFromName" />
      <FormSection name="emails">
        <div className={styles.emailGroup}>
          <ToggleFieldComponent name="invitation" label="Invitation" />
          <AppTextField name="invitationTemplateId" label="Email Template Id" key="invitationTemplateId" />
        </div>
        <div className={styles.emailGroup}>
          <ToggleFieldComponent name="reminder" label="First Reminder" />
          <AppTextField name="reminderTemplateId" label="Email Template Id" key="reminderTemplateId" />
        </div>
        <div className={styles.emailGroup}>
          <ToggleFieldComponent name="secondReminder" label="Second Reminder" />
          <AppTextField name="secondReminderTemplateId" label="Email Template Id" key="secondReminderTemplateId" />
        </div>
        <div className={styles.emailGroup}>
          <ToggleFieldComponent name="rejection" label="Rejection" />
          <AppTextField name="rejectionTemplateId" label="Email Template Id" key="rejectionTemplateId" />
        </div>
        <div className={styles.emailGroup}>
          <ToggleFieldComponent name="confirmation" label="Confirmation" />
          <AppTextField name="confirmationTemplateId" label="Email Template Id" key="confirmationTemplateId" />
        </div>
        <div className={styles.emailGroup}>
          <ToggleFieldComponent name="firstEventReminder" label="Event Reminder" />
          <AppTextField
            name="firstEventReminderTemplateId"
            label="Email Template Id"
            key="firstEventReminderTemplateId"
          />
        </div>
        <div className={styles.emailGroup}>
          <ToggleFieldComponent name="secondEventReminder" label="Second Event Reminder" />
          <AppTextField
            name="secondEventReminderTemplateId"
            label="Email Template Id"
            key="secondEventReminderTemplateId"
          />
        </div>
        <div className={styles.emailGroup}>
          <ToggleFieldComponent name="eventStartReminder" label="Event Start Reminder" />
          <AppTextField
            name="eventStartReminderTemplateId"
            label="Email Template Id"
            key="eventStartReminderTemplateId"
          />
        </div>
        <div className={styles.emailGroup}>
          <ToggleFieldComponent name="clipReadyReminder" label="Clip Ready Reminder" />
          <AppTextField
            name="clipReadyReminderTemplateId"
            label="Email Template Id"
            key="clipReadyReminderTemplateId"
          />
        </div>
        <div className={styles.emailGroup}>
          <ToggleFieldComponent name="secondClipReadyReminder" label="Second Clip Ready Reminder" />
          <AppTextField
            name="secondClipReadyReminderTemplateId"
            label="Email Template Id"
            key="secondClipReadyReminderTemplateId"
          />
        </div>
        <div className={styles.emailGroup}>
          <ToggleFieldComponent name="thirdClipReadyReminder" label="Third Clip Ready Reminder" />
          <AppTextField
            name="thirdClipReadyReminderTemplateId"
            label="Email Template Id"
            key="thirdClipReadyReminderTemplateId"
          />
        </div>
        <div className={styles.emailGroup}>
          <ToggleFieldComponent name="partiallyRejection" label="Partially Rejection" />
          <AppTextField
            name="partiallyRejectionEmailTemplateId"
            label="Email Template Id"
            key="partiallyRejectionEmailTemplateId"
          />
        </div>
      </FormSection>
    </Collapsible>
  </div>
);
